import * as React from 'react';

import * as moment from 'moment';
import { withTranslation } from 'react-i18next';

import { type InjectedI18nProps } from '~/utils/translate';

const momentLocaleLoader = (Component) =>
  withTranslation()(
    // eslint-disable-next-line @typescript-eslint/ban-types
    class extends React.Component<InjectedI18nProps, {}> {
      componentDidMount() {
        // Default moment locale is en so we only load locales when it is not en or en-US
        if (this.props.i18n.language !== 'en' && this.props.i18n.language !== 'en-US') {
          const language = this.props.i18n.language;
          import(`moment/locale/${language}`)
            .then(() => {
              moment.locale(language);
            })
            .catch(() => {});
        }
      }

      render() {
        return <Component {...this.props} />;
      }
    },
  );

export default momentLocaleLoader;
